<template>
  <img src="/logo.png" alt="Лого" class="logo" width="89" height="25" />
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.logo {
  aspect-ratio: 3.56;
}
</style>
